import React from 'react';
import styled from 'styled-components';

const FooterDiv = styled.div`
  font-size: 14px;
  text-align: center;
  margin: 32px 0;
`;

export const Footer: React.FC = () => {
  return (
    <FooterDiv>
      <a href="https://www.almato.com/datenschutz/" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      {' · '}
      <a href="https://www.almato.com/impressum/" target="_blank" rel="noopener noreferrer">
        Imprint
      </a>
    </FooterDiv>
  );
};
